// NOTE: must be kept in sync with
// packages/fountain-ui-components/src/utils/assertUnreachable.ts
// packages/recruiter-ui/app/utils/assertUnreachable.ts
export function assertUnreachable(condition: never, metadata?: string): never {
  throw new Error(
    `Unknown condition reached: ${condition as string} - ${metadata ?? ''}`,
  );
}
